import { render, staticRenderFns } from "./LessonSection.vue?vue&type=template&id=0313e926&scoped=true"
import script from "./LessonSection.vue?vue&type=script&lang=js"
export * from "./LessonSection.vue?vue&type=script&lang=js"
import style0 from "./LessonSection.vue?vue&type=style&index=0&id=0313e926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313e926",
  null
  
)

export default component.exports